import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n';
import { SectionLoadErrorState } from '../settings-devices-configuration.style';

interface SettingsDevicesConfigurationLayoutSectionLoadErrorProps {
    onRetry: VoidFunction;
}

export const SettingsDevicesConfigurationLayoutSectionLoadError: React.FC<
    SettingsDevicesConfigurationLayoutSectionLoadErrorProps
> = ({ onRetry }) => {
    const { t } = useTranslation();

    return (
        <SectionLoadErrorState>
            <PocTypography variant="title3">
                {t('settings.devices.device-settings.device-config-layout.section-load-error.title')}
            </PocTypography>
            <PocTypography variant="body1">
                {t('settings.devices.device-settings.device-config-layout.section-load-error.description')}
            </PocTypography>
            <PocButton onClick={onRetry}>
                {t('settings.devices.device-settings.device-config-layout.section-load-error.action.retry')}
            </PocButton>
        </SectionLoadErrorState>
    );
};
